import React from "react";
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/splide/dist/css/splide.min.css';
import { testimonies } from '../../portfolio';
import Quote from '../../assets/images/blockquote.svg';
import { Fade } from "../reveal/Fade";
import "./Testimonials.css";

const Testimonials = ({ theme }) => {
  return (
    <section className="testimonial-container">
      <div className="title">
        <Fade bottom duration={1000} distance="20px">
          <h1 className="skills-header" style={{ color: theme?.text }}>
            Recommandations
          </h1>
        </Fade>
      </div>

      <Fade bottom duration={1000} distance="20px">
        <div className="slider-container">
          <blockquote>
            <img className="top-quote quote" src={Quote} alt="quote" />
            <img className="bottom-quote quote" src={Quote} alt="quote" />
          </blockquote>

          <Splide
            options={{
              perPage: 1,
              autoplay: false,
              //interval: 15000,
              speed: 800,
              rewind: true,
              rewindByDrag: true,
            }}
          >
            {testimonies.map((testimonial) => (
              <SplideSlide key={testimonial.id}>
                <img
                  className="review-img"
                  src={require(`../../assets/images/${testimonial.image}`)}
                  alt={testimonial.name}
                />
                <div className="content">
                  <p className="text">{testimonial.text}</p>
                  <div className="info">
                    <p className="user">{testimonial.name}</p>
                  </div>
                </div>
              </SplideSlide>
            ))}
          </Splide>
        </div>
      </Fade>
    </section>
  );
};

export default Testimonials;
